export default function script_loadingSplash() {
  $(window).on('load', function(){     //ページ内のすべての要素が読み込まれた後に動作を行う
    setTimeout(function(){  //すべての要素が読み込まれた後0.5秒後にスタート
      $(".Load").fadeOut("slow");  //ロード幕のフェードアウト
      $(".Load__logo").css({transform: 'scale(5) translateY(-500px)'});  //ロゴが拡大し、上部へ移動する
    }, 500);
  });
}
